
























import Vue from "vue"
import FloatingButton from "~/components/guideline/button/FloatingButton.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"
import ButtonFloatingFrame from "~/components/custom/buttonFrame/BottomFloatingFrame.vue"
import RoundFavoriteIconButton from "~/components/custom/favoriteButton/RoundFavoriteIconButton.vue"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"

export default Vue.extend({
  components: {
    MaterialIcon,
    FloatingButton,
    ButtonFloatingFrame,
    RoundFavoriteIconButton,
  },
  props: {
    isFavorited: {
      type: Boolean,
      required: true,
    },
    isScoutableUser: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
    isAvailableScout(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.USER_SCOUT)
    },
  },
  methods: {
    handleClickFavoriteIcon(): void {
      this.$emit("click-favorite-icon")
    },
    handleClickScoutButton(): void {
      this.$emit("click-scout-button")
    },
  },
})
